import { Route, Switch } from "react-router";
import { AppRouteUi } from "../../../config/appRoute";
import { RedirectRoute } from "../../../components/redirectRoute";
import { PageUsersView } from "./pageUsersView";
import { PageUserAdd } from "./pageUserAdd";
import { PageUserUpdate } from "./pageUserUpdate";
import { PageSingleUser } from "./pageSingleUser";

export function PageUsers(): JSX.Element {
  return (
    <div className="">
      <Switch>
        <Route path={AppRouteUi.Users.List()} exact component={PageUsersView} />
        <Route path={AppRouteUi.Users.Add()} exact component={PageUserAdd} />
        <Route path={AppRouteUi.Users.Update()} component={PageUserUpdate} />
        <Route path={AppRouteUi.Users.ById()} component={PageSingleUser} />
        <RedirectRoute
          from={AppRouteUi.Users.Root()}
          to={AppRouteUi.Users.List()}
          wildcardOpt={{
            defaultTo404Page: true,
          }}
        />
      </Switch>
    </div>
  );
}
